import React, { useContext } from 'react';
import context from '../../../../hoc/context/product/context';
import RichText from '../../../../hoc/components/rich-text';
import InformationPanel from '../../../../hoc/components/information-panel';
import Section from '../../../../hoc/components/section/section';

export const NpafFooter = () => {
	const ctxt = useContext(context);
	return (
		<Section
			title={ctxt.json.pages.confirmation.npaf.title}
			description={ctxt.json.pages.confirmation.npaf.description} 
			width="max-w-2xl">
			{ctxt.json.pages.confirmation.npaf.contact && (
				<div>
					<InformationPanel>
						<RichText html={ctxt.json.pages.confirmation.npaf.contact} />
					</InformationPanel>
				</div>
			)}
		</Section>
	);
};

export default NpafFooter;
